module.exports = __webpack_public_path__ + "static/floralwrapandhead-5a6416098d39dd025d5fba526d015141.jpeg";